/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { DraftCreate } from '../../../../types/DraftCreate';

export const DraftCreateRequest: core.serialization.Schema<
    serializers.DraftCreateRequest.Raw,
    Omit<Truvity.DraftCreateRequest, 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    data: DraftCreate,
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace DraftCreateRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        data: DraftCreate.Raw;
        labels?: Record<string, string> | null;
    }
}
